import { IEndpointData } from 'SharedDir/declarations/shared';
import { SERVER_API } from 'SharedDir/constants/app/endpoints';

const timetableExceptionkUrl = `${SERVER_API}/timetable`;

export const TIMETABLE_EXCEPTION = {
  LIST: {
    method: 'GET',
    url: `${timetableExceptionkUrl}`,
  } as IEndpointData,
  STORE: {
    method: 'POST',
    url: `${timetableExceptionkUrl}`,
  } as IEndpointData,
  DELETE(id: number): IEndpointData {
    return {
      method: 'DELETE',
      url: `${timetableExceptionkUrl}/${id}`,
    };
  },
};
